import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeAllModals } from '../../../actions/modalActions';
import { GATTIN, POSTSTOD } from '../../../constants/paths/urls';
import useKeyboardEvent from '../../../hooks/useKeyboardEvent';
import ISettingsViewModel from '../../../interfaces/umbracoNodes/settingsViewModel';
import Button from '../../base/button';
import { Column, Columns } from '../../base/grid';
import { A } from '../../base/typography';
import * as StyledModal from './companyServicePortalModal.styles';

interface Props {}

const CompanyServicePortalModal: FC<Props> = () => {
	const dispatch = useDispatch<any>();
	const { settings }: { settings: ISettingsViewModel } = useSelector(
		(state: { pageReducer: { settings: ISettingsViewModel } }) => state.pageReducer
	);

	const onServicePortalAnchorClick = () => {
		dispatch(closeAllModals());
	};

	useKeyboardEvent('Escape', () => closeAllModals());
	// TODO: Fix
	return (
		<StyledModal.Wrapper>
			<Columns>
				<Column tablet={1 / 2}>
					<StyledModal.ServicePortalTile>
						<StyledModal.ServicePortalImage image={settings.Values.GattinImage.Src} />
						<StyledModal.ServiceTileContent>
							{settings.Values.GattinTitle}
							<p>{settings.Values.GattinInfo}</p>

							<A to={GATTIN} target="_blank" onClick={onServicePortalAnchorClick}>
								<Button primary>{settings.Values.GattinButton}</Button>
							</A>
						</StyledModal.ServiceTileContent>
					</StyledModal.ServicePortalTile>
				</Column>

				<Column tablet={1 / 2}>
					<StyledModal.ServicePortalTile>
						<StyledModal.ServicePortalImage image={settings.Values.PoststodinImage.Src} />
						<StyledModal.ServiceTileContent>
							{settings.Values.PoststodinTitle}
							<p>{settings.Values.PoststodinInfo}</p>

							<A
								to={POSTSTOD}
								target="_blank"
								onClick={onServicePortalAnchorClick}
								arial-label="poststod">
								<Button primary>{settings.Values.PoststodinButton}</Button>
							</A>
						</StyledModal.ServiceTileContent>
					</StyledModal.ServicePortalTile>
				</Column>
			</Columns>
		</StyledModal.Wrapper>
	);
};

export default CompanyServicePortalModal;
